// event-questions.js

// Actions
import store from '../../admin/store'
export const DELETE_QUESTION_ACTION = 'DELETE_QUESTION_ACTION'

// Reducer
const initialState = {}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DELETE_QUESTION_ACTION: {
            const { ...questions } = state
            delete questions[action.question.id]
            return questions
        }
        default:
            return state
    }
}

// Action creators
export const deleteQuestionAction = question => ({
    type: DELETE_QUESTION_ACTION,
    question,
})

const toggleBusy = () => ({
    type: 'TOGGLE_BUSY_SECTION',
    section: 'admin.events.attendance',
})

// Thunks
export const deleteQuestion = (slug, question) => {
    store.dispatch(toggleBusy())

    return window.axios
        .delete(
            `${window.APP_CONFIG.REACT_APP_API_URL}api/attendance-questions/${question.id}`
        )
        .then(
            () => {
                store.dispatch(toggleBusy())
                store.dispatch(deleteQuestionAction(question))
            },
            () => store.dispatch(toggleBusy())
        )
}
